import React, { Component } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';
import logo from './../img/lead-hawk-ai-logo.png';
import { UserDropdown } from './UserDropdown';

export class NavMenu extends Component {
    static displayName = NavMenu.name;

    constructor(props) {
        super(props);

        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.state = {
            collapsed: true
        };
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }

    render() {
        var siteheaderstyle = {
            
        };

        if (this.props.isIframe) {
            siteheaderstyle = {
                display: "none"
            };
        }



        return (
            <header className="site-header" style={siteheaderstyle} >

                <Container className="container-fluid">
                    <NavbarBrand className="site-logo" tag={Link} to="/Home">
                        <img src={logo} height="50"  alt="LeadHawkAI" />
                    </NavbarBrand>
                    <UserDropdown />
                   

                </Container>

            </header>
        );
    }
}
